export const FEATURE_NAME = 'CultureChest';
